module.exports = __webpack_public_path__ + "img/gift-11-c1.fdb421fa.png";